import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Select from 'react-select';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { parseJSON } from '../../utils/helpers';

const Rule = () => {
  const dispatch = useDispatch();
  const { rule_id } = useParams();

  const { rule, actions, conditions, timeTemplates, ruleGroups, simulateRun } = useSelector((state) => state.general);

  const [showRuleGroups, setShowRuleGroups] = useState(false);

  console.log({ rule, simulateRun });
  const updateRuleById = (ruleId, changes) => {
    dispatch(
      apiAction({
        reduxField: 'rule',
        route: `rules/updateRuleById`,
        ruleId,
        changes,
      })
    );
  };

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'rule',
        route: `rules/getRuleById`,
        ruleId: rule_id,
      })
    );
    dispatch(apiAction({ reduxField: 'actions', route: 'actions/getActions' }));
    dispatch(apiAction({ reduxField: 'conditions', route: 'conditions/getConditions' }));
    dispatch(
      apiAction({
        reduxField: 'timeTemplates',
        route: 'timeTemplates/getTimeTemplates',
      })
    );
  }, [dispatch, rule_id]);

  if (rule?._id !== rule_id) {
    dispatch(
      generalSet({
        reduxField: 'rule',
        value: null,
      })
    );
  }

  if (!rule?._id || !Array.isArray(actions) || !Array.isArray(conditions) || !Array.isArray(timeTemplates)) {
    return <Spinner />;
  }

  return (
    <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
          <h1>
            Rule Details: <span className='text-primary'>{rule.name}</span>
          </h1>
        </div>
      </div>

      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0'>
          <Link className='btn btn-outline-dark' to={`/RunRuleById/${rule._id}`}>
            Run Rule
          </Link>
        </div>
      </div>

      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-md-6 d-flex justify-content-center align-items-center border p-2 mt-2'>
          <b className='mr-2'>Condition:</b>{' '}
          <Select
            className='col-md-6'
            options={conditions.map((condition) => ({
              value: condition._id,
              label: condition.name,
            }))}
            placeholder={conditions.find((condition) => condition._id === rule.conditionId)?.name}
            onChange={(selectedOption) => updateRuleById(rule._id, { conditionId: selectedOption.value })}
            isSearchable
          />
          <a
            className='btn btn-outline-primary'
            title='View Condition'
            href={`/condition/${rule.conditionId}`}
            target='_blank'
            rel='noreferrer'
          >
            <i className='fa fa-eye' aria-hidden='true'></i>
          </a>
        </div>
        <div className='col-md-6 d-flex justify-content-center align-items-center border p-2 mt-2'>
          <b className='mr-2'>Action:</b>{' '}
          <Select
            className='col-md-6'
            options={actions.map((action) => {
              const actionData = parseJSON(action.actionData);
              return {
                value: action._id,
                label: actionData?.name,
              };
            })}
            placeholder={parseJSON(actions.find((action) => action._id === rule.actionId)?.actionData)?.name}
            onChange={(selectedOption) => updateRuleById(rule._id, { actionId: selectedOption.value })}
            isSearchable
          />
          {/* <select
            className='btn btn-outline-dark select'
            defaultValue={rule.actionId}
            onChange={(e) => updateRuleById(rule._id, { actionId: e.target.value })}
          >
            {actions.map((act) => (
              <option key={act._id} value={act._id}>
                {parseJSON(act.actionData).name}
              </option>
            ))}
          </select> */}
          <a
            className='btn btn-outline-primary'
            title='View Action'
            href={`/action/${rule.actionId}`}
            target='_blank'
            rel='noreferrer'
          >
            <i className='fa fa-eye' aria-hidden='true'></i>
          </a>
        </div>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0'>
        <div className='col-md-12 d-flex justify-content-center align-items-center border p-2 mt-2'>
          <b className='mr-2'>Frequency:</b>{' '}
          <select
            className='btn btn-outline-dark select'
            defaultValue={rule.frequency}
            onChange={(e) => updateRuleById(rule._id, { frequency: e.target.value })}
          >
            <option value='DAILY'>Daily</option>
            <option value='HOURLY'>Hourly</option>
            <option value='HALF_HOURLY'>Half Hourly</option>
            <option value='SPECIFIC_TIME'>Specific Time</option>
            <option value='TIME_TEMPLATE'>Time Template</option>
          </select>
        </div>
      </div>

      {rule.frequency === 'SPECIFIC_TIME' && (
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-12 d-flex justify-content-center'>
            <small>
              <b>Note: </b> All rules are under UTC timzone{' '}
            </small>
          </div>
          <div className='col-md-4'>
            {rule.specificTime.map((time) => (
              <div key={time._id} className='d-flex justify-content-between align-items-center'>
                <select
                  className='form-control'
                  value={time.hour}
                  onChange={(e) =>
                    updateRuleById(rule._id, {
                      specificTime: rule.specificTime.map((t) =>
                        t._id === time._id ? { ...t, hour: e.target.value } : t
                      ),
                    })
                  }
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={i}>
                      {i}
                    </option>
                  ))}
                </select>
                <select
                  className='form-control'
                  value={time.minute || 0}
                  onChange={(e) =>
                    updateRuleById(rule._id, {
                      specificTime: rule.specificTime.map((t) =>
                        t._id === time._id ? { ...t, minute: e.target.value } : t
                      ),
                    })
                  }
                >
                  <option value={0}>00</option>
                  <option value={30}>30</option>
                </select>
                <button
                  className='btn btn-outline-danger'
                  onClick={() =>
                    updateRuleById(rule._id, { specificTime: rule.specificTime.filter((t) => t._id !== time._id) })
                  }
                >
                  <i className='fa fa-trash' aria-hidden='true'></i>
                </button>
              </div>
            ))}
            <button
              className='btn btn-outline-dark mt-2'
              onClick={() =>
                updateRuleById(rule._id, { specificTime: [...rule.specificTime, { hour: 12, minute: 0 }] })
              }
            >
              Add Time
            </button>
          </div>
        </div>
      )}
      {rule.frequency === 'TIME_TEMPLATE' && (
        <>
          <div className='row d-flex justify-content-center mt-4'>
            <div className='col-md-12 d-flex justify-content-center'>
              <h6>Choose a Template</h6>
            </div>
            <Select
              className='col-md-4'
              defaultValue={{
                label: timeTemplates.find((template) => template._id === rule.timeTemplateId)?.name,
                value: rule.timeTemplateId,
              }}
              options={timeTemplates.map((template) => ({
                value: template._id,
                label: template.name,
              }))}
              placeholder='Search or select a template'
              onChange={(selectedOption) => {
                updateRuleById(rule._id, { timeTemplateId: selectedOption.value });
              }}
              isSearchable
            />
          </div>
        </>
      )}
      <div className='row d-flex justify-content-center border p-2 mt-2'>
        <div className='col-md-12 d-flex justify-content-center'>
          <h6>Rule Status (Active/Inactive)</h6>
        </div>
        <button
          className={`btn btn-sm btn-${rule.isActive ? 'primary' : 'outline-secondary'}`}
          onClick={() => updateRuleById(rule._id, { isActive: !rule.isActive })}
        >
          {rule.isActive ? 'Active' : 'Inactive'}
        </button>
      </div>

      <div className='row d-flex justify-content-center border p-2 mt-2'>
        {showRuleGroups ? (
          <>
            {ruleGroups ? (
              <>
                <div className='col-md-12 d-flex justify-content-center'>
                  <h6>Rule Groups</h6>
                </div>
                <div className='col-md-12 d-flex justify-content-center'>
                  {ruleGroups.map((ruleGroup) => {
                    if (ruleGroup.ruleIds.includes(rule._id)) {
                      return (
                        <Link
                          key={ruleGroup._id}
                          className='btn btn-outline-dark ml-2'
                          to={`/ruleGroup/${ruleGroup._id}`}
                        >
                          {ruleGroup.name}
                        </Link>
                      );
                    }
                    return null;
                  })}
                </div>
              </>
            ) : (
              <Spinner />
            )}
          </>
        ) : (
          <button
            className='btn btn-outline-primary'
            onClick={() => {
              dispatch(apiAction({ reduxField: 'ruleGroups', route: 'ruleGroups/getRuleGroups' }));

              setShowRuleGroups(true);
            }}
          >
            Show Rule Groups
          </button>
        )}
      </div>

      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-6 d-flex justify-content-center align-items-center p-2 mt-2'>
          <b className='mr-2'>Created At:</b> {new Date(rule.createdAt).toLocaleString()}
        </div>
        <div className='col-md-6 d-flex justify-content-center align-items-center p-2 mt-2'>
          <b className='mr-2'>Updated At:</b> {new Date(rule.updatedAt).toLocaleString()}
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <button
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'simulateRun',
                route: `rules/simulateRunCheck`,
                ruleId: rule._id,
              })
            );
          }}
        >
          Simulate Run
        </button>
      </div>
    </div>
  );
};

export default Rule;
